import { ACCOUNT__ID } from '../../Constants/constant';
import { axiosInstance } from '../../Utils/apiServices';

/**
 * Send/Resend OTP to email or mobile
 * @param {{id: string}} payload will have either mobile or email
 */
export const requestForOTP = async (payload) => {
  const path = `otprequest?contact=${payload.id}`;
  const res = await axiosInstance.request({ url: `${encodeURI(path)}`, method: 'post' });
  return res && res.data ? res.data : null;
};

export const requestOneTimeOtp = async (payload) => {
  const path = `onetimepassword?email=${payload.id}&phone=${payload.phone}`;
  return axiosInstance.request({ url: path, method: 'post' }).then((res) => res.data);
};

/**
 * Verify OTP for user login or signup
 * @param {{id: string, otp: string}} payload will verify otp for email or mobile
 */
export const verifyOTP = async (payload) => {
  const path = `otpverify?contact=${payload.id}&otpentered=${payload.otp}&course=${payload.course}`;
  return axiosInstance.request({ url: `${path}`, method: 'get' }).then((res) => res.data);
};

export const verifyOneTimeOTP = async (payload) => {
  const path = `verifyonetimepassword?contact=${payload.id}&otp=${payload.otp}`;
  return axiosInstance.request({ url: `${path}`, method: 'get' }).then((res) => res.data);
};

/**
 * User Signup Request
 * @param {*} payload
 */
export const signUp = async (payload) => {
  const path = `signup`;

  return axiosInstance
    .request({
      url: `${path}`,
      method: 'post',
      data: {
        applicant: {
          FirstName: payload.firstName,
          LastName: payload.lastName,
          Middle_Name__c: payload.middleName,
          Email: payload.email,
          Phone: payload.phone,
          Interested_Courses__c: payload.course,
          // AccountId: ACCOUNT__ID,
          // date: payload.date,
          // program: payload.program,
        },
      },
    })
    .then((res) => res.data);
};
